<template>
  <div>
    <div class="nome">{{ _.get(trItem, 'value', 'n/d') }}</div>
    <div class="percorso">
      <span v-if="1">{{ marca | capitalize}} > {{ modello | capitalize }}</span>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "crudTableMagazzinoDescrizione",
  props: ["trItem"],
  directives: {},
  data() {
    return {
      marca: "",
      modello: ""
      //VARIABILI AMBIENTE
    };
  },
  computed: {
    ...mapState(["loginStates"]),
    ...mapGetters({
      selettore: "ordineStates/selettore"
    })
  },
  methods: {
    //RESTITUISCE SINGOLA FOLDER DI UN PATH
    //DA DARE IN PASTO A GETLABEL PER LEGGERE LA LABEL DI UNA CARTELLA
    findPathFolder(path, folder) {
      let filtrato = {};
      if(path!==undefined){
      filtrato = path.filter(function(nodo) {
        return nodo.hasOwnProperty(folder);
      });
      if (filtrato.length > 0) {
       
        return filtrato[0];
      }
    }
    }
  },
  mounted() {
    //let marche = this.findPath(this.trItem.path,'marche')

    this.$store
      .dispatch(
        "magazzinoStates/getLabel",
        this.findPathFolder(this.trItem.path, "marche")
      )
      .then(result => {
        this.marca = result.label;
      });
    this.$store
      .dispatch(
        "magazzinoStates/getLabel",
        this.findPathFolder(this.trItem.path, "modelli")
      )
      .then(result => {
        this.modello = result.label;
      });
  },
  watch: {},
  filters: {
    capitalize: function(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      let value = splitStr.join(" ");
      if (!value) return "";
      value = value.toString();
      return value.replace("Iphone", "iPhone");
    }
  }
};
</script>

<style scoped>
.nome {
  font-weight: 500;
  text-transform: capitalize;
}

.percorso {
 
  font-weight: 200;
  font-size: 1.7vh;
}

.fade {
  -webkit-animation: fade-in 0.01s;
  animation: fade-in 0.01s;
}

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
